export default __webpack_public_path__ + "static/media/menuCopiar.0b4e2514.svg";